/* @flow */

import AccurateTimestamp from '../../helpers/dateTime/AccurateTimestamp';
import HotKeys from '../../helpers/hotKeys/hotKeys';

// Elapsed time is checked every minute (in ms)
const DEFAULT_INTERVAL = 60_000;

// Zero activity period can last up to 4h (in ms)
const DEFAULT_DURATION = 14_400_000;

export default class PresenceChecker {
  checkInterval: number;
  intervalId: IntervalID | null;
  noActivityDuration: number; // Duration in ms
  noActivityThreshold: number; // Timestamp in ms
  onNoActivityDetected: () => Promise<void>;

  constructor(onNoActivityDetected: () => Promise<void>, checkInterval: number = DEFAULT_INTERVAL, noActivityDuration: number = DEFAULT_DURATION) {
    this.checkInterval = checkInterval;
    this.intervalId = null;
    this.noActivityDuration = noActivityDuration;
    this.noActivityThreshold = 0;
    this.onNoActivityDetected = onNoActivityDetected;

    this.start();
  }

  acknowledgeActivity = () => {
    this.noActivityThreshold = AccurateTimestamp.now() + this.noActivityDuration;
  };

  start = () => {
    this.stop();

    document.addEventListener('mousemove', this.acknowledgeActivity, { passive: true });
    document.addEventListener('mousedown', this.acknowledgeActivity, { passive: true });
    HotKeys.registerAnyKey(this.acknowledgeActivity);

    this.acknowledgeActivity();
    this.intervalId = setInterval(this.check, this.checkInterval);
  };

  stop = () => {
    if (this.intervalId !== null) {
      clearInterval(this.intervalId);
      this.intervalId = null;
    }

    document.removeEventListener('mousemove', this.acknowledgeActivity, { passive: true });
    document.removeEventListener('mousedown', this.acknowledgeActivity, { passive: true });
    HotKeys.unregisterAnyKey();
  };

  check = (): Promise<void> | void => {
    if (AccurateTimestamp.now() > this.noActivityThreshold) {
      // Stop checking and notify player
      this.stop();
      return this.onNoActivityDetected();
    }
  };
}
